import { theme } from './../../Assets/Styles/theme'

export const styles = {
  container: {
    display: 'flex',
    '& + *': {
      marginLeft: '5px',
    },
  },
  input: {
    display: 'flex',
    border: `1px solid ${theme.colors.iron}`,
    width: 92,
    background: 'white',
    padding: '0 35px 0 15px',
    boxSizing: 'content-box',
    lineHeight: '40px',
    color: '#546b81',
    position: 'relative',
    zIndex: 2,
    backgroundColor: 'transparent',

    '&:hover': {
      cursor: 'pointer',
    },
  },
  datePickerHeaderTitle: {
    color: theme.colors.regentGray,
    fontSize: 14,
    alignSelf: 'center',
    fontWeight: 700,
    marginRight: 10,
  },
  inputWrapper: {
    position: 'relative',
    backgroundColor: 'white',
  },
  deleteIcon: {
    position: 'absolute',
    width: 10,
    height: '12px',
    right: 25,
    top: 0,
    zIndex: 2,
    transform: 'rotate(90deg)',
    fill: theme.colors.secondary,
    cursor: 'pointer',
    margin: '15px',
  },
  icon: {
    position: 'absolute',
    width: 13,
    height: '12px',
    right: 0,
    top: 0,
    zIndex: 1,
    transform: 'rotate(90deg)',
    fill: theme.colors.secondary,
    cursor: 'pointer',
    margin: '15px',
  },
}
